import { Alert, Box, Button, Typography } from "@mui/material";
import Container from "@mui/material/Container";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function VerifyTokenFaile(props) {
  const [searchParams] = useSearchParams();
  const errorMessage = searchParams.get("message");
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center",
        maxWidth: 500,
        margin: "0 auto",
      }}
    >
      <Container
        maxWidth="sm"
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",

          padding: "0px",
          width: "565px",
          maxWidth: "90vw",
          height: "380px",
          backgroundColor: "common.white.main",
        }}
      >
        <Typography
          variant="h5"
          sx={{ mb: 3, textAlign: "center", width: "100%" }}
        >
          パスワード更新画面を開けません
        </Typography>
        <Alert severity="error" sx={{ mb: 3, width: "100%" }}>
          以下の理由により更新画面を開けません
        </Alert>
        <Typography
          variant="body1"
          sx={{ mb: 2, textAlign: "start", fontWeight: "bold", color: "red" }}
        >
          {errorMessage}
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, textAlign: "start" }}>
          ※「トークンの有効期限切れ」の場合、「再設定リンク」を再度送信願います。
          <br />
          ※「トークンの有効期限切れ」以外の場合、システム部へ問い合わせ願います。
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            navigate("/password_reset_mail");
          }}
          sx={{ mt: 2 }}
        >
          「再設定リンク」を再送信
        </Button>
      </Container>
    </Box>
  );
}
